<div class="group/textarea h-full">
    <div
        class="border-grey-400 group-hover/textarea:border-blue relative mt-5 box-border flex h-full flex-wrap border-2 transition-all"
        [ngClass]="{
            'border-red': error(),
        }"
    >
        <label class="relative flex grow flex-col justify-center" [for]="inputId">
            <span
                class="text-12 group-hover/textarea:text-blue absolute -top-14 left-0 bg-white px-12 leading-27 text-black transition-all duration-300"
                [ngClass]="{
                    'text-red': error(),
                }"
            >
                {{ label() }}
            </span>
            <textarea
                class="h-full min-h-48 w-full bg-white px-16 pt-10 text-black outline-none lg:min-h-full"
                [ngClass]="greyPlaceholder() ? '' : 'placeholder:text-black'"
                [ngStyle]="{ height: defaultHeightValue() }"
                [placeholder]="placeholder()"
                [value]="value() ?? null"
                [readOnly]="readonly()"
                [attr.aria-describedby]="error() && errorMsg() ? errorId : null"
                [id]="inputId"
                (input)="setValue($event)"
                (focus)="_onTouch?.(); focussed.set(true)"
                (blur)="focussed.set(false)"
            ></textarea>
        </label>
    </div>
    @if (error() && errorMsg()) {
        <div class="h-16">
            <p class="text-12 text-red relative leading-16" [id]="errorId" role="alert">
                {{ errorMsg() }}
            </p>
        </div>
    }
</div>
